import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import setNotes from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";
import { getValidPreferredDate } from "@rugby/App/Handlers/CheckoutShipping/UpdateCart";

export const CustomPopulateApiParameter = (props: any) => {
    if (!props.cartToUpdate) {
        return;
    }

    props.apiParameter = {
        cart: {
            ...props.cartToUpdate,
            properties: {
                ...props.cartToUpdate.properties,
                job: props.parameter?.job,
                achAccountNumber: props.parameter?.achAccountNumber,
                bankGuid: props.parameter?.bankGuid,
            },
            ...getValidPreferredDate(props.getState(), props.cartToUpdate),
        },
    };
};

export const UpdateCartNotes = (props: any) => {
    const state = props.getState();
    props.cartToUpdate = {
        ...props.cartToUpdate,
        notes: props.cartToUpdate.notes || state.pages.checkoutShipping.editedCartNotes
    }
};

export const ResetCartNotes = (props: any) => {
    props.dispatch(setNotes({ notes: "" }));
};

addToChainAfter(chain, SetCartStatus, UpdateCartNotes);
addToChainAfter(chain, ExecuteOnSuccessCallback, ResetCartNotes);
replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);
